module.exports = __webpack_public_path__ + "static/media/art60.0935308a.jpg";